<template>
    <img :src="currentComp" :class="{
        'h-[64px] w-[64px]': size === 'md',
        'h-[100px] w-[100px]': size === 'lg',
        'h-[32px] w-[32px]': size === 'sm'
    }" />
</template>

<script setup lang="ts">
import projectOne from '@/assets/images/projects/1.png'
import projectTwo from '@/assets/images/projects/2.png'
import projectThree from '@/assets/images/projects/3.png'
import projectFour from '@/assets/images/projects/4.png'
import projectFive from '@/assets/images/projects/5.png'
import projectSix from '@/assets/images/projects/6.png'

import _ from 'lodash'
import { computed } from 'vue'
import type { TIconType, TSize } from '@/types'

const typeMap = {
    1: projectOne,

    2: projectTwo,

    3: projectThree,

    4: projectFour,

    5: projectFive,

    6: projectSix,
};

const props = withDefaults(defineProps<{
    icon: TIconType
    size: TSize
}>(), {
    size: 'md',
})

const currentComp = computed(() => {
    return _.get(typeMap, props.icon, projectOne)
})

</script>
